// import { iProductDetails } from "../product/Types";

// export const REDUCER_NAME='wholesalerSlice'
// export interface iWholesalerDTO {
//     id?:string;
//     profilePicture?:string;
//     firstName?: string;
//     lastName?: string;
//     mobile?: string;
//     email?: string;
//     password?: string;
//     kycStatus?:string;
//     confirmPassword?: string;
//     businessName?: string;
//     ownerName?: string;
//     gstNumber?: string;
//     businessType?: string;
//     streetAddress?: string;
//     city?: string;
//     state?: string;
//     pinCode?: string;
//     bankAccountNumber?: string;
//     ifscCode?: string;
//     bankName?: string;
//     accountHolderName?: string;
//     aadharNumber?:string;
//     panNumber?:string;
//     deliveryType?:string[];
//     serviceCategory?:string[];
//     deliveryLocations?: string[];
//     deliveryCountry?: string[];
//     deliveryState?: string[];
//     isDocumentVerified?:Boolean;
//     businessDocument?:ibusinessDocument[]|null;
//     isApproved:number

//   }

//   interface ibusinessDocument{
//     id?:string;
//     documentType: string;
//     documentImage: string | File;
//   }

//   interface iconnectionRequestList{
//     id: string;
//     vendorId: string;
//     wholesalerId: string;
//     isApproved: number;
//     status: number;
//     createdAt: string;
//     updatedAt: string;
//     vendorFirstName: string | null;
//     vendorLastName: string | null;
//     wholesalerFirstName: string | null;
//     wholesalerLastName: string | null;
//   }
// export interface wholersalerCategoryList{
//   id:string,
//   name:String
// }
// export interface connectionStatus{
//   isFree:boolean,
//   charge:number,
//   message:string,
// }
//   export interface iWholesalerState {
//       wholesalerList: iWholesalerDTO[] | null;
//       isLoading: boolean;
//       errorMessage: string | null;
//       wholesalerProductList: iProductDetails[] | null;
//       resalerRequestList:iconnectionRequestList[] | null;
//       wholesalerDetail:iWholesalerDTO|null;
//       wholersalerCategoryList:wholersalerCategoryList[],
//       connectionStatus:connectionStatus
//   }

//   export interface iconnectWithWholesaler{
//     vendorId:string;
//     wholesalerId:string;
//     isApproved?:string
//   }
  

//   export interface iKYCApproved{
//     message?:string;
//     kycStatus?:string;
//   }

import { iProductDetails } from "../product/Types";

export const REDUCER_NAME='wholesalerSlice'
export interface iWholesalerDTO {
    isVerified: number;
    originCity: any;
    originPostalCode: any;
    originCountry: any;
    id?:string;
    profilePicture?:string;
    firstName?: string;
    lastName?: string;
    mobile?: string;
    email?: string;
    password?: string;
    kycStatus?:string;
    confirmPassword?: string;
    businessName?: string;
    ownerName?: string;
    gstNumber?: string;
    businessType?: string;
    streetAddress?: string;
    city?: string;
    state?: string;
    pinCode?: string;
    bankAccountNumber?: string;
    ifscCode?: string;
    bankName?: string;
    accountHolderName?: string;
    aadharNumber?:string;
    panNumber?:string;
    deliveryType?:string[];
    serviceCategory?:string[];
    deliveryLocations?: string[];
    deliveryCountry?: string[];
    deliveryState?: string[];
    isDocumentVerified?:Boolean;
    businessDocument?:ibusinessDocument[]|null;
    isApproved:number

  }

  interface ibusinessDocument{
    id?:string;
    documentType: string;
    documentImage: string | File;
  }

  interface iconnectionRequestList{
    id: string;
    vendorId: string;
    wholesalerId: string;
    isApproved: number;
    status: number;
    createdAt: string;
    updatedAt: string;
    vendorFirstName: string | null;
    vendorLastName: string | null;
    wholesalerFirstName: string | null;
    wholesalerLastName: string | null;
  }
export interface wholersalerCategoryList{
  id:string,
  name:String
}
export interface connectionStatus{
  isFree:boolean,
  charge:number,
  message:string,
  isConnected:boolean,
}
export interface iPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

 export interface iWholesalerState {
  myWholesalerList: iWholesalerDTO[] | null;
  allWholesalerList: iWholesalerDTO[] | null;
  vendorWholesalerList: iWholesalerDTO[] | null;

  isLoading: boolean;
  errorMessage: string | null;

  wholesalerProductList: iProductDetails[];
  resalerRequestList: iconnectionRequestList[] | null;
  wholesalerDetail: iWholesalerDTO | null;
  wholersalerCategoryList: wholersalerCategoryList[];
  connectionStatus: connectionStatus;
  pagination: iPagination | null;
}

  export interface iconnectWithWholesaler{
    vendorId:string;
    wholesalerId:string;
    isApproved?:string
  }
  

  export interface iKYCApproved{
    message?:string;
    kycStatus?:string;
  }